import { getRegion } from '../../common/region/region.js'

export const FEATURE_SELL = 'FEATURE_SELL'
export const FEATURE_RETURN_LABELS = 'FEATURE_RETURN_LABELS'
export const FEATURE_P2P = 'FEATURE_P2P'
export const FEATURE_CREDITS = 'FEATURE_CREDITS'
export const FEATURE_TYPES_PAGE = 'FEATURE_TYPES_PAGE'
export const FEATURE_BAG_PICKUP = 'FEATURE_BAG_PICKUP'
export const FEATURE_HM_COLLAB_BUY = 'FEATURE_HM_COLLAB_BUY'
export const FEATURE_BAG_SUBSCRIPTION = 'FEATURE_BAG_SUBSCRIPTION'
export const FEATURE_STATEMENT = 'FEATURE_STATEMENT'
export const FEATURE_SELL_SIGNUP = 'FEATURE_SELL_SIGNUP'
export const FEATURE_KLARNA_COLLAB_BUY = 'FEATURE_KLARNA_COLLAB_BUY'
export const FEATURE_SNAPCHAT_COLLAB_BUY = 'FEATURE_SNAPCHAT_COLLAB_BUY'
export const FEATURE_FASHIONWEEK_COLLAB_BUY = 'FEATURE_FASHIONWEEK_COLLAB_BUY'
export const FEATURE_CONTAINER_TRACKING_LINKS = 'FEATURE_CONTAINER_TRACKING_LINKS'
export const FEATURE_BLACK_FRIDAY = 'FEATURE_BLACK_FRIDAY'
export const FEATURE_ANDC_COLLAB = 'FEATURE_ANDC_COLLAB'
export const FEATURE_AUTOMATIC_PAYOUT = 'FEATURE_AUTOMATIC_PAYOUT'
export const FEATURE_EXPRESS_ASSORTMENT = 'FEATURE_EXPRESS_ASSORTMENT'
export const FEATURE_RETURN_FREIGHT_VARIABLE = 'FEATURE_RETURN_FREIGHT_VARIABLE'
export const FEATURE_KLARNA_DIRECT_INTEGRATION = 'FEATURE_KLARNA_DIRECT_INTEGRATION'

export const ALL_FEATURE_TOGGLES = [
  FEATURE_SELL,
  FEATURE_RETURN_LABELS,
  FEATURE_P2P,
  FEATURE_CREDITS,
  FEATURE_TYPES_PAGE,
  FEATURE_BAG_PICKUP,
  FEATURE_HM_COLLAB_BUY,
  FEATURE_BAG_SUBSCRIPTION,
  FEATURE_STATEMENT,
  FEATURE_SELL_SIGNUP,
  FEATURE_KLARNA_COLLAB_BUY,
  FEATURE_SNAPCHAT_COLLAB_BUY,
  FEATURE_FASHIONWEEK_COLLAB_BUY,
  FEATURE_CONTAINER_TRACKING_LINKS,
  FEATURE_BLACK_FRIDAY,
  FEATURE_ANDC_COLLAB,
  FEATURE_AUTOMATIC_PAYOUT,
  FEATURE_EXPRESS_ASSORTMENT,
  FEATURE_RETURN_FREIGHT_VARIABLE,
  FEATURE_KLARNA_DIRECT_INTEGRATION
]

export const REGION_FEATURES = {
  SE: [
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_RETURN_LABELS,
    FEATURE_P2P,
    FEATURE_CREDITS,
    FEATURE_TYPES_PAGE,
    FEATURE_BAG_PICKUP,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_STATEMENT,
    FEATURE_KLARNA_COLLAB_BUY,
    FEATURE_SNAPCHAT_COLLAB_BUY,
    FEATURE_FASHIONWEEK_COLLAB_BUY,
    FEATURE_CONTAINER_TRACKING_LINKS,
    FEATURE_BLACK_FRIDAY,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_HM_COLLAB_BUY
  ],
  DE: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_FASHIONWEEK_COLLAB_BUY,
    FEATURE_SNAPCHAT_COLLAB_BUY,
    FEATURE_CONTAINER_TRACKING_LINKS,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  AT: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_FASHIONWEEK_COLLAB_BUY,
    FEATURE_RETURN_FREIGHT_VARIABLE,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  NL: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_CREDITS,
    FEATURE_ANDC_COLLAB,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  BE: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_CREDITS,
    FEATURE_ANDC_COLLAB,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  EU: [FEATURE_RETURN_LABELS, FEATURE_SELL_SIGNUP, FEATURE_CREDITS, FEATURE_HM_COLLAB_BUY],
  DK: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_BAG_PICKUP,
    FEATURE_SNAPCHAT_COLLAB_BUY,
    FEATURE_RETURN_FREIGHT_VARIABLE,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  PL: [
    FEATURE_RETURN_LABELS,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_HM_COLLAB_BUY,
    FEATURE_EXPRESS_ASSORTMENT
  ],
  FI: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_BAG_PICKUP,
    FEATURE_SNAPCHAT_COLLAB_BUY,
    FEATURE_RETURN_FREIGHT_VARIABLE,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  FR: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_EXPRESS_ASSORTMENT,
    FEATURE_HM_COLLAB_BUY
  ],
  CZ: [
    FEATURE_RETURN_LABELS,
    FEATURE_TYPES_PAGE,
    FEATURE_CREDITS,
    FEATURE_BAG_SUBSCRIPTION,
    FEATURE_SELL,
    FEATURE_AUTOMATIC_PAYOUT,
    FEATURE_KLARNA_DIRECT_INTEGRATION,
    FEATURE_HM_COLLAB_BUY,
    FEATURE_EXPRESS_ASSORTMENT
  ]
}

// We store which features are toggled to their opposite state only to have new features follow the default state
const FEATURES_TOGGLED_KEY = 'featuresToggled'

export const getFeatureToggle = () => {
  const lsData = window.localStorage.getItem(FEATURES_TOGGLED_KEY)
  const lsToggles = lsData && JSON.parse(lsData)
  const featureToggles = ALL_FEATURE_TOGGLES.filter((feature) => {
    const isDefaultFeatureActive = REGION_FEATURES[getRegion()].includes(feature)
    return lsToggles?.includes(feature) ? !isDefaultFeatureActive : isDefaultFeatureActive
  })
  return featureToggles
}

export const setFeatureToggle = (features) => {
  const toggledFeatures = ALL_FEATURE_TOGGLES.filter(
    (feature) => REGION_FEATURES[getRegion()].includes(feature) !== features.includes(feature)
  )
  window.localStorage.setItem(FEATURES_TOGGLED_KEY, JSON.stringify(toggledFeatures))
}

export const isFeatureEnabled = (feature) => {
  if (!ALL_FEATURE_TOGGLES.includes(feature)) return true
  const featureToggles = getFeatureToggle()
  return featureToggles.includes(feature)
}

export const requireFeature = (feature) => (Component) => {
  const requireFeature = (props) =>
    isFeatureEnabled(feature || props.requiredFeature) ? <Component {...props} /> : null
  return requireFeature
}
